import styled from 'styled-components';
import Avatar from 'antd/lib/avatar';

export const StyledAvatar = styled(Avatar)`
  margin: 0 0 0 0.75rem;
`;
